import {
  Button,
  EditButton,
  Space,
  Table,
  useTable,
} from "@pankod/refine-antd";
import { useApiUrl, useCustom } from "@pankod/refine-core";

import { Caches, IStockLevel, Product } from "Interfaces";
import { Fragment, useEffect, useState } from "react";
import {
  getBulkRefreshFromProntoStatus,
  startBulkRefreshFromPronto,
  updateStockLevelCache,
} from "Services/productServices";
import dayjs from "dayjs";
export const StockLevelPanel = () => {
  const { tableProps, tableQueryResult } = useTable<IStockLevel>({
    resource: "products/checkStockLevels",
  });

  const apiUrl = useApiUrl();

  const { data: lastUpdatedData, refetch: lastUpdatedRefetch } =
    useCustom<Caches>({
      url: `${apiUrl}/caches`,
      method: "get",
      config: {
        query: {
          key: "mismatchedStockLevel",
        },
      },
    });

  const lastUpdated = lastUpdatedData?.data;
  const lastUpdatedDate = lastUpdated?.[0]?.updated_at;

  const [isLoading, setIsLoading] = useState(false);

  const [bulkStatus, setBulkStatus] = useState<
    | {
        status: string;
        startedAt?: string;
        startedBy?: string;
        finishedAt?: string;
        totalProducts?: number;
        processedProducts?: number;
        lastError?: string | null;
      }
    | undefined
  >(undefined);

  const isBulkRunning = bulkStatus?.status === "running";

  const refreshBulkStatus = async () => {
    try {
      const response = await getBulkRefreshFromProntoStatus();
      setBulkStatus(response.data);
    } catch (e) {
      // ignore status errors in UI; leave previous state
    }
  };

  useEffect(() => {
    refreshBulkStatus();

    if (!isBulkRunning) {
      return;
    }

    const interval = setInterval(() => {
      refreshBulkStatus();
    }, 10000);

    return () => clearInterval(interval);
  }, [isBulkRunning]);

  const handleGetFreshData = async () => {
    setIsLoading(true);
    await updateStockLevelCache();
    setIsLoading(false);
    tableQueryResult.refetch();
    lastUpdatedRefetch();
  };

  const handleBulkRefresh = async () => {
    if (
      !window.confirm(
        "This will queue a refresh from Pronto for all products. This may take some time and should only be run occasionally. Continue?"
      )
    ) {
      return;
    }

    try {
      await startBulkRefreshFromPronto();
      await refreshBulkStatus();
    } catch (e) {
      // Silently fail here; refine notifications/toasts can be added later if needed
    }
  };

  //get the last upadted value from the cahce table
  // const lastUpdated = tableQueryResult?.data?.data?.lastUpdated;

  return (
    <Fragment>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems:"center" }}>
          {/* <div>Last refresh:</div>
          <div style={{ marginLeft: "20px" }}> */}
          <div>
          Last refresh:&nbsp;<b>{dayjs(lastUpdatedDate).format("D MMM YY HH:mm ")}</b>
          </div>
          <div style={{ marginLeft: "10px" }}>
            <Button loading={isLoading} onClick={handleGetFreshData}>
              Refresh Stock Levels
            </Button>
            <Button
              style={{ marginLeft: "8px" }}
              onClick={handleBulkRefresh}
              disabled={isBulkRunning}
            >
              Sync All From Pronto
            </Button>
          </div>
        </div>
        {bulkStatus && bulkStatus.status && (
          <div style={{ marginTop: "6px", fontSize: "12px" }}>
            Bulk status: <b>{bulkStatus.status}</b>
            {bulkStatus.startedAt && (
              <>
                {" "}from {dayjs(bulkStatus.startedAt).format("D MMM YY HH:mm ")}
              </>
            )}
            {typeof bulkStatus.processedProducts === "number" &&
              typeof bulkStatus.totalProducts === "number" && (
                <>
                  {" "}- {bulkStatus.processedProducts}/{bulkStatus.totalProducts} processed
                </>
              )}
          </div>
        )}
        <div style={{ marginTop: "10px" }}>
          <Table {...tableProps} rowKey="sku">
            <Table.Column<IStockLevel> dataIndex="sku" title="Sku" sorter />
            <Table.Column<IStockLevel>
              dataIndex="prontoCount"
              title="Pronto SOH"
              sorter
            />
            <Table.Column<IStockLevel>
              dataIndex="strapiCount"
              title="Strapi SOH"
              sorter
            />
            <Table.Column<Product>
              title="Link"
              dataIndex="actions"
              render={(_, record) => (
                <Space>
                  <EditButton
                    resourceNameOrRouteName="products"
                    size="small"
                    recordItemId={record.id}
                  />
                </Space>
              )}
            />
          </Table>
        </div>
      </div>
    </Fragment>
  );
};
